/* eslint-disable no-console */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable import/prefer-default-export */
import React, { useState, useCallback, useEffect } from 'react'
import { FileInput } from '../../../FileInput'
import s from './CoverImage.module.css'

export function CoverImage({ id }) {
  const [inProgress, setInProgress] = useState(false)
  const [fileImageUrl, setFileImageUrl] = useState('')
  const [fileImage, setFileImage] = useState('')

  useEffect(() => {
    async function getCover() {
      try {
        const apiToken = localStorage.getItem('apiToken')

        const response = await fetch(`/api/v3/listing_collections/${id} `, {
          headers: {
            'API_TOKEN': apiToken,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'GET',
        })

        const data = await response.json()

        if (data.cover_photo_url) {
          setFileImageUrl(data.cover_photo_url)
        }

        // eslint-disable-next-line no-console
        console.log(data)
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error)
      }
    }

    getCover()
  }, [id, inProgress])

  const handleUpdateCover = useCallback(async () => {
    try {
      setInProgress(true)
      const apiToken = localStorage.getItem('apiToken')

      const formData = new FormData()

      formData.append('listing_collection[cover_photo]', fileImage)

      const response = await fetch(`/api/v3/listing_collections/${id}`, {
        headers: {
          API_TOKEN: apiToken,
        },
        method: 'PUT',
        body: formData,
      })

      const data = await response.json()
      console.log(data)
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
    } finally {
      setInProgress(false)
    }
  }, [fileImage])

  return (
    <div className={s.root}>
      <div className={s.title}>Cover Image</div>
      <FileInput
        isLoading={inProgress}
        label="Upload cover image"
        initialFileUrl={fileImageUrl}
        onFileChange={(file) => setFileImage(file)}
        onRemove={() => setFileImage(null)}
        accept="image/*"
      />

      <div className={s.controls}>
        <button type="button" className={s.update} disabled={inProgress} onClick={handleUpdateCover}>
          {inProgress ? 'Updating...' : 'Update'}
        </button>
      </div>
    </div>
  )
}
